import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported } from "firebase/messaging";
import api from "./api/api";

const firebaseConfig = {
  apiKey: "AIzaSyDpIp4FniiStg-bwfGMWfMVvKv9oi6T-Mk",
  authDomain: "bookmybeauty-salon.firebaseapp.com",
  projectId: "bookmybeauty-salon",
  storageBucket: "bookmybeauty-salon.firebasestorage.app",
  messagingSenderId: "753270597152",
  appId: "1:753270597152:web:4aa5ef3fdc1d918f853e45",
  measurementId: "G-VZSRV8V682",
};

const VAPID_KEY =
  "BCIt37hhH2rfFXcTrlUuakkVHjhVb7Sg7IP9KpTaKbBvQ0GPYVip3pRZT-RWmGmueVS2sAzWYQdIjf2O-YV_NX0";

const app = initializeApp(firebaseConfig);

let messaging: ReturnType<typeof getMessaging> | null = null;

const getMessagingInstance = async () => {
  if (messaging) return messaging;
  const supported = await isSupported();
  if (!supported) return null;
  messaging = getMessaging(app);
  return messaging;
};

export const generateDeviceToken = () => {
  let deviceToken = localStorage.getItem("device_token");
  if (!deviceToken) {
    deviceToken = `${Date.now()}-${Math.random()
      .toString(36)
      .substring(2, 15)}`;
    localStorage.setItem("device_token", deviceToken);
  }
  return deviceToken;
};

const saveFCMToken = (token: string) => {
  localStorage.setItem("fcm_token", token);
};

export const getSavedFCMToken = () => {
  return localStorage.getItem("fcm_token");
};

export const getSavedDeviceToken = () => {
  return localStorage.getItem("device_token");
};

export const needsNotificationPermission = () => {
  if (typeof window === "undefined" || !("Notification" in window)) {
    return false;
  }
  const existingFcm = getSavedFCMToken();
  if (existingFcm && Notification.permission === "granted") {
    return false;
  }
  // Show prompt when permission is undecided, or granted but token missing
  return (
    Notification.permission === "default" ||
    (Notification.permission === "granted" && !existingFcm)
  );
};

/**
 * Request browser notification permission, fetch FCM token,
 * and sync it to the backend for the current logged-in admin.
 */
export const requestNotificationPermission = async (): Promise<{
  success: boolean;
  fcmToken?: string;
  reason?: string;
}> => {
  try {
    if (!("Notification" in window)) {
      return { success: false, reason: "Notifications are not supported on this browser." };
    }

    const messagingInstance = await getMessagingInstance();
    if (!messagingInstance) {
      return { success: false, reason: "Push messaging is not supported on this device." };
    }

    let permission = Notification.permission;
    if (permission === "default") {
      permission = await Notification.requestPermission();
    }

    if (permission !== "granted") {
      return { success: false, reason: "Notification permission was denied." };
    }

    const fcmToken = await getToken(messagingInstance, { vapidKey: VAPID_KEY });
    if (!fcmToken) {
      return { success: false, reason: "Unable to generate notification token." };
    }

    const deviceToken = generateDeviceToken();
    saveFCMToken(fcmToken);

    const accessToken = localStorage.getItem("accesstoken");
    if (accessToken) {
      await api.post("/v1/admin/refresh/adminfcmtoken", {
        fcmToken,
        deviceToken,
      });
    }

    return { success: true, fcmToken };
  } catch (error) {
    console.error("Error getting notification permission:", error);
    return {
      success: false,
      reason: "Failed to enable notifications. You can try again later.",
    };
  }
};

export { messaging };
